export type NationalExamTab = 'exam' | 'video' | 'qcm'

export type NationalExamItem = {
  _id?: string
  id?: string
  title?: string
  name?: string
  level?: '6eme' | '9eme'
  year?: number
  examYear?: number
  schoolYear?: string
  session?: string
  file?: string | {_id?: string; id?: string; name?: string}
  fileId?: string
  file_id?: string
  fileUrl?: string
  /** Additional exam page images (multi-upload); `fileUrl` remains primary PDF or first image. */
  imageUrls?: string[]
  correctionUrl?: string
  correctionImageUrls?: string[]
  /** Optional server count when URLs are omitted from list payloads. */
  correctionCount?: number
  videoUrl?: string
  url?: string
  link?: string
  viewUrl?: string
  embedUrl?: string
  youtubeUrl?: string
  youtubeVideoId?: string
  thumbnailUrl?: string
  subject?: string | {name?: string; _id?: string}
  createdAt?: string
  description?: string
  quizUrl?: string
  externalUrl?: string
  isPublished?: boolean
  isDeleted?: boolean
  /** Editorial boost for homepage recommendations (admin). */
  isFeatured?: boolean
  downloadCount?: number
  viewCount?: number
  trendingScore?: number
  isTrending?: boolean
  /** Present on continue-row items when joined from UserExamHistory. */
  progressPercent?: number
  lastPage?: number
  lastOpenedAt?: string
  completed?: boolean
  [key: string]: unknown
}

export type NationalExamsMeta = {
  type: NationalExamTab
  levelApplied: '6eme' | '9eme' | 'all' | string
  page: number
  limit: number
  total: number
  totalPages?: number
}

/** Root `meta` on `GET /api/national-exams/homepage`. */
export type NationalExamsHomepageMeta = {
  levelApplied: string
  cachedAt?: string
}

export function getNationalExamDocId(item: NationalExamItem): string | undefined {
  const raw = item._id ?? item.id
  if (typeof raw === 'string' && raw.trim()) {
    return raw.trim()
  }
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    return String(raw)
  }
  if (raw && typeof raw === 'object' && '$oid' in raw) {
    const oid = (raw as { $oid?: unknown }).$oid
    if (typeof oid === 'string' && oid.trim()) {
      return oid.trim()
    }
  }
  const altKeys = ['documentId', 'examId', 'nationalExamId', 'examDocumentId', 'document_id'] as const
  for (const k of altKeys) {
    const v = item[k]
    if (typeof v === 'string' && v.trim()) {
      return v.trim()
    }
  }
  return undefined
}
